package app.bloomey.web.modules.auth

import com.copperleaf.ballast.*
import com.copperleaf.ballast.core.BasicViewModel
import com.copperleaf.ballast.core.LoggingInterceptor
import kotlinx.coroutines.CoroutineScope

class AuthViewModel(private val coroutineScope: CoroutineScope) :
    BasicViewModel<AuthContract.Inputs, AuthContract.Events, AuthContract.State>(
        config = BallastViewModelConfiguration.Builder()
            .apply {
                this += LoggingInterceptor()
            }
            .withViewModel(
                inputHandler = AuthInputHandler(),
                initialState = AuthContract.State(),
                name = "HomePage",
            )
            .build(),
        eventHandler = eventHandler {
        },
        coroutineScope = coroutineScope
    )